import script from "./Details.vue?vue&type=script&setup=true&lang=ts"
export * from "./Details.vue?vue&type=script&setup=true&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=939784f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-939784f2"]])

export default __exports__